<template>
  <div class="revision-manager">
    <nav class="uk-navbar-container revision-manager__nav" uk-navbar>
      <div class="uk-navbar-left">
        <div class="uk-navbar-item uk-logo">
          Revisionen für:&nbsp;
          <slot name="title">{{parent.name}}</slot>
        </div>
      </div>
      <div class="uk-navbar-right">
        <div class="uk-navbar-item">
          <cancel-button class="uk-margin-right" :text="$t('actions.back')" />
        </div>
      </div>
    </nav>

    <table class="revision-manager__grid uk-table uk-table-divider"
           v-if="hasRevisions">
      <thead class="revision-manager__grid-header">
        <tr>
          <th class="revision-manager__header uk-table-shrink uk-text-right">
            {{$t('historicalData')}}
          </th>
          <th v-for="revision in revisions"
              class="revision-manager__cell revision-manager__header"
              :class="{ 'revision-manager__header--active': revision.active }">
            <revision-validity
              :from="revision.validFrom"
              :until="revision.validUntil"
            />
            <live-indicator
              v-if="revision.active"
              class="uk-align-right uk-margin-remove"
            />
          </th>
          <th class="revision-manager__header uk-table-shrink">
            <router-link
              v-if="newRevisionRoute"
              :to="newRevisionRoute"
              :title="$t('actions.addRevision')"
            >
              <icon name="plus"></icon>
            </router-link>
            <a
              v-else
              href="#"
              @click.prevent="addRevision"
              :title="$t('actions.addRevision')"
            >
              <icon name="plus"></icon>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="field in fields">
          <td class="revision-manager__cell uk-table-shrink uk-text-right uk-text-bold">
            {{$t(`fields.${field}`)}}
          </td>
          <td v-for="revision in revisions"
              class="revision-manager__cell"
              :class="{ 'revision-manager__cell--active': revision.active }">
            <slot :name="field" :value="revision[field]">
              <span v-if="revision[field]">{{revision[field]}}</span>
              <text-placeholder v-else />
            </slot>
          </td>
          <td class="revision-manager__cell uk-table-shrink"></td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="revision-manager__footer uk-table-shrink"></td>
          <td v-for="revision in revisions"
              class="revision-manager__footer"
              :class="{ 'revision-manager__footer--active': revision.active }">
            <common-button @click="editRevision(revision)" icon="pencil">
              {{$t('actions.edit')}}
            </common-button>
            <common-button @click="deleteRevision(revision)"
                           type="danger" icon="trash">
              {{$t('actions.delete')}}
            </common-button>
          </td>
          <td class="revision-manager__footer uk-table-shrink"></td>
        </tr>
      </tfoot>
    </table>

    <div class="uk-text-center uk-margin-large uk-margin-large-top uk-margin-large-left uk-margin-large-right" v-else>
      {{$t('hints.noRevisions')}}

      <div class="uk-margin-top">
        <link-button v-if="newRevisionRoute" :to="newRevisionRoute"
                     size="large" icon="plus">
          {{$t('actions.addRevision')}}
        </link-button>
        <common-button v-else @click="addRevision" size="large" icon="plus">
          {{$t('actions.addRevision')}}
        </common-button>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from 'uikit';
import CancelButton from '@/components/CancelButton';
import CommonButton from '@/components/CommonButton';
import LinkButton from '@/components/LinkButton';
import LiveIndicator from '@/components/LiveIndicator';
import RevisionValidity from '@/components/RevisionValidity';
import TextPlaceholder from '@/components/TextPlaceholder';

export default {
  name: 'revision-manager',
  components: {
    CancelButton,
    CommonButton,
    LinkButton,
    LiveIndicator,
    RevisionValidity,
    TextPlaceholder,
  },
  props: {
    parent: {
      type: Object,
      required: true,
    },
    revisions: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    newRevisionRoute: Object,
  },
  computed: {
    isSuccessfullyLoaded() {
      return this.isLoaded && this.revisions;
    },
    hasRevisions() {
      return this.revisions.length > 0;
    },
  },
  methods: {
    addRevision() {
      this.$emit('add');
    },
    editRevision(revision) {
      this.$emit('edit', revision);
    },
    deleteRevision(revision) {
      UIkit.modal
           .confirm(this.$t('confirmations.delete'))
           .then(() => { this.$emit('delete', revision); })
           .catch(() => {});
    },
  },
  i18n: {
    messages: {
      de: {
        historicalData: 'Stammdaten',
        actions: {
          addRevision: 'Revision hinzufügen',
          back: 'Zurück',
        },
        confirmations: {
          delete: 'Möchtest du die ausgewählte Revision wirklich löschen?',
        },
        hints: {
          noRevisions: 'Es gibt noch keine Revisionen.',
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../theme/variables.scss';

.revision-manager__nav {
  border-bottom: 1px solid $global-border;
}

.revision-manager__grid {
  margin: 0;

  th, td {
    &:not(:first-child) {
      border-left: 1px solid $global-border;
    }
  }
}

.revision-manager__header--active {
  background-color: rgba($global-primary-background, 0.05);
  color: $global-primary-background;
}

</style>



// WEBPACK FOOTER //
// RevisionManager.vue?7ee08610